import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=1811d8e0&scoped=true&"
import script from "./RolePage.vue?vue&type=script&lang=js&"
export * from "./RolePage.vue?vue&type=script&lang=js&"
import style0 from "./RolePage.vue?vue&type=style&index=0&id=1811d8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811d8e0",
  null
  
)

export default component.exports